module.exports = __webpack_public_path__ + "8081456f9aca08676df4540c468d31e7.jpg";